<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import Locales from '@/localization/locales'
import mixins from 'mixins'

export default {
  name: 'App',
  mixins: [mixins],
  created () {
    Locales.locale = window.locale
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue